import AnalyticServiceVendor from '../../enums/analytics-service-vendor-type';
import { ThemisAnalyticsOptionsValidationError } from '../../errors/themis-analytics-options-validation.error';
export default class ThemisAnalyticsOptionsValidator {
    validate(options) {
        var _a, _b;
        const errors = [];
        if ((options === null || options === void 0 ? void 0 : options.client) === undefined) {
            errors.push('"client" is a required option');
        }
        else {
            if (options.client === AnalyticServiceVendor.GoogleTagManager) {
                if (!((_b = (_a = options === null || options === void 0 ? void 0 : options.config) === null || _a === void 0 ? void 0 : _a.gtmService) === null || _b === void 0 ? void 0 : _b.gtmId)) {
                    errors.push('"gtmService.gtmId" is a required option');
                }
            }
        }
        if (errors.length) {
            throw new ThemisAnalyticsOptionsValidationError(errors.join('. '));
        }
        return true;
    }
}
//# sourceMappingURL=themis-analytics-options.validator.js.map